import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiAccountsResendActivation extends ApiBase {
  private static baseUrl: string = '/accounts/resendactivation';

  static async post(email: string): Promise<any> {
    const url = this.baseUrl;

    const data = {
      mail: email,
    };

    const config = {};

    return await this.sendRequest(METHOD.POST, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
